import React from 'react';
import './App.css';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Home from './Home.js';
import PortfolioAll from './Components/Portfolio/PortfolioAll';
import Default from './Default';
import ScrollTop from './Components/ScrollTop/ScrollTop';

function App() {

  return (
    <div className="App">
        <Router>
          <Navbar/>
            <Switch>
                <Route exact path="/" component={Home}></Route>
                <Route exact path="/portfolio" component={PortfolioAll}></Route>
                <Route exact path="*" component={Default}></Route>
            </Switch>
            <Footer/>
            <ScrollTop/>
        </Router>
    </div>
  );
}

export default App;
